import React, { useCallback, useEffect, useState } from "react";
import "./PostPaymet.css";
import InputField from "../../../../../newComponents/form-fields/InputField";
import H5 from "../../../../../newComponents/typography/H5";
import SelectField from "../../../../../newComponents/form-fields/SelectField";
import apiHelper from "../../../../../utils/apiHelper";
import { PayPaymentDueAccountVM, PaymentMethodTypesEnum, PaymentService } from "@propertelligent/client-api";
import { getEnumOptions } from "../../../../../utils/enumHelpers";
import { useForm, FormProvider } from "react-hook-form";
import { NotificationType, PubSub, TopicsEnum } from "../../../../../utils/pubsub";
import SimpleButton from "../../../../../newComponents/buttons/Simple-button";
import AddTraspButton from "../../../../firstTimeUserExperience/commonCom/AddTraspButton";
import UtilHelper from "../../../../../utils/UtilHelper";
import { TextCss } from "../../../../GlobalCss/TextCss";
import TenantTabContent from "../../../../../newComponents/tabs/tabs/tab-pages/tenant-tab-content";
import CurrencyTooltip from "../../../../currencytooltip/CurrencyTooltip";

// Payment recording modes -- mirrors PaymentMethodTypesEnum on the backend.
// An Organization can never Plaid-pay its own receivable, so this drawer
// only ever offers the manual recording modes.
const PAYMENT_MODE = PaymentMethodTypesEnum;
const PAYMENT_MODE_OPTIONS = getEnumOptions(PAYMENT_MODE, [
  PAYMENT_MODE.Cash,
  PAYMENT_MODE.Check,
  PAYMENT_MODE.Other,
  PAYMENT_MODE.Assisted,
]);

const PostPayment = ({ data, tenantId, setShowModel, payDueAccountId,feestype=undefined }) => {
  const methods = useForm();
  const { handleSubmit } = methods;
  const [totalAmount, setTotalAmount] = useState(0);
  const [paymentDetail,setPaymentDetails] =useState()
  const [duesToSettle, setDuesToSettle] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const selectedMode = Number(methods.watch("paymentMethodTypeId"));

   const fetchInitialData = useCallback(async () => {
      // setIsLoading(true);
      try {
        const paymentDetail = await apiHelper(
          PaymentService.getApiPaymentDueAccountReceivable,
          { showNotification: false },
          tenantId
        );

   setPaymentDetails(paymentDetail?.data?.success)
      } catch (error) {
        PubSub.publish(TopicsEnum.Notification.toString(), {
          message: "Failed to load required data",
          type: NotificationType.Failure,
        });
      } finally {
        // setIsLoading(false);
      }
    }, [tenantId ]);
     const fetchPaymentTenantlist = async () => {
  const res = await apiHelper(
    PaymentService.getApiPaymentDueAccountTenantlist,
    { showNotification: false },
    tenantId
  );

  return res?.data?.success || [];
};

  useEffect(() => {
    fetchInitialData();
    fetchPaymentTenantlist()
  }, [fetchInitialData]);

//  useEffect(() => {
//   fetchPaymentTenantlist().then((list) => {
//     const normalizedIds = Array.isArray(payDueAccountId)
//       ? payDueAccountId.map(id => Number(id))
//       : [];

//     const filtered = list.filter(due =>
//       normalizedIds.includes(Number(due.id))
//     );

//     setDuesToSettle(filtered);
//   });
// }, [payDueAccountId]);
 useEffect(() => {
  if (!Array.isArray(payDueAccountId) || payDueAccountId.length === 0) {
    setDuesToSettle([]);
    return;
  }

  fetchPaymentTenantlist().then((list) => {
   
    const normalizedIds = payDueAccountId.map(id => Number(id));
    const filtered = list.filter(due =>
      normalizedIds.includes(Number(due.id))
    );
    setDuesToSettle(filtered);
  });
}, [payDueAccountId]);
const onSubmit = async (formData) => {
  if (isSubmitting) return;

  if (!duesToSettle.length) {
    PubSub.publish(TopicsEnum.Notification.toString(), {
      message: "No dues found to settle",
      type: NotificationType.Warning,
    });
    return;
  }

  const paymentMethodTypeId = Number(formData.paymentMethodTypeId);

  setIsSubmitting(true);
  try {
    const paymentPromises = duesToSettle.map((due) => {
      const payload: PayPaymentDueAccountVM = {
        payDueAccountId: Number(due.id),
        amount: Number(due.amount),
        paymentMethodTypeId,
        paymentDate: new Date(formData.date).toISOString(),
      };

      if (paymentMethodTypeId === PAYMENT_MODE.Check) {
        payload.checkNumber = formData?.checkNum;
      } else if (paymentMethodTypeId === PAYMENT_MODE.Other) {
        payload.transactionId = formData?.transactionId;
      } else if (paymentMethodTypeId === PAYMENT_MODE.Assisted) {
        payload.assistanceProvider = formData?.assistanceProvider;
      }

      return apiHelper(
        PaymentService.putApiPaymentDueAccountPay,
        { showNotification: false },
        payload
      );
    });

    await Promise.all(paymentPromises);

    PubSub.publish(TopicsEnum.Notification.toString(), {
      message: "Payment posted successfully",
      type: NotificationType.Success,
    });
    PubSub.publish(TopicsEnum.RefreshLeaseData.toString(), null);
    setShowModel(false);
  } catch (error) {
    PubSub.publish(TopicsEnum.Notification.toString(), {
      message: "Failed to post payment",
      type: NotificationType.Failure,
    });
  } finally {
    setIsSubmitting(false);
  }
};


useEffect(() => {
  const total = duesToSettle.reduce(
    (sum, due) => sum + Number(due.amount || 0),
    0
  );
  setTotalAmount(total);
}, [duesToSettle]);
  return (
    <div className="post-payment-container">
      
        <div className="payment-card justify-content-between">
          <div className="d-flex gap-3">
          <div className="tenant-avatar">
            <div className="tenant-initials">{UtilHelper.getInitials(data?.firstName + " " + data?.lastName)}</div>
          </div>
          <div className="">
            <p className={TextCss.black.heading_700_16}>{data?.fullName}</p>
            <p className={TextCss.grey_neutral.sub_heading_400_14}>{feestype}</p>
          </div>
          </div>
          <div className={` ${TextCss.black.main_heading_700_20}`}>
              <CurrencyTooltip 
                formatted={totalAmount}
                content={totalAmount}
              >
                  <span>{totalAmount}</span>
                </CurrencyTooltip>
            </div>
        </div>
        {/* <div className="post-payment-form"> */}
        <FormProvider {...methods}>
          <form className="payment-form" onSubmit={handleSubmit(onSubmit)}>
            <div className=" p-3 post-payment-form">
              <div className="payment-form-finput d-flex gap-4 ">
                <SelectField
                  placeholderText="Select Payment Mode"
                  name="paymentMethodTypeId"
                  label="Payment Mode"
                  required
                  requiredMessage="Payment Mode is required"
                  options={PAYMENT_MODE_OPTIONS}
                />
                <InputField
                  name="date"
                  label="Payment Date"
                  type="date"
                  required
                  requiredMessage="Payment Date is required"
                />
              </div>
              {selectedMode === PAYMENT_MODE.Check && (
                <div className="col-md-6 mb-1">
                  <InputField
                    name="checkNum"
                    label="Check No"
                    type="text"
                    required
                    requiredMessage="Check No is required"
                  />
                </div>
              )}
              {selectedMode === PAYMENT_MODE.Other && (
                <div className="col-md-6 mb-1">
                  <InputField
                    name="transactionId"
                    label="Transaction ID"
                    type="text"
                    required
                    requiredMessage="Transaction ID is required"
                  />
                </div>
              )}
              {selectedMode === PAYMENT_MODE.Assisted && (
                <div className="col-md-6 mb-1">
                  <InputField
                    name="assistanceProvider"
                    label="Assistance Provider"
                    type="text"
                    required
                    requiredMessage="Assistance Provider is required"
                    allowSpecialChars={true}
                  />
                </div>
              )}
            </div>

            <div className="form-actions-footer">
              <AddTraspButton bname="Cancel" border={false} onClick={() => setShowModel(false)} type="button" />
              <SimpleButton type="submit" label={isSubmitting ? "Posting..." : "Post Payment"} isDisabled={isSubmitting} />
            </div>
          </form>
        </FormProvider>
      {/* </div> */}
    </div>
  );
};

export default PostPayment;


